module.exports = __webpack_public_path__ + "static/media/audible-logo.b8f90409.png";


//////////////////
// WEBPACK FOOTER
// ./src/new_components/generic/png/audible-logo.png
// module id = 7357
// module chunks = 4